import axios from 'axios';

export default {
  // Admin
  getAdminPVActivation: (entityId) => {
    return axios.get(`/api/pv/admin/activations/${entityId}`)
      .then(response => {
        return {
          activation: response.data.activation != null
            ? response.data.activation : {},
          }});
  },

  findAdminAllReceipts: (data) => {
    return axios.put('/api/pv/admin/allreceipts', data)
      .then(response => {
        return {
          receipts: response.data.receipts != null
            ? response.data.receipts : [],
          receiptsTotal: response.data.receiptsTotal != null
            ? response.data.receiptsTotal : 0,
          }});
  },

  updateAdminReceiptByKey: (data) => {
    return axios.put(`/api/pv/admin/receipts/${data.receiptId}/bykey`, data)
      .then(response => {
        return {
          receipt: response.data.receipt != null
            ? response.data.receipt : {},
          }});
  },

  getAdminReceipt: (data) => {
    return axios.get(`/api/pv/admin/receipts/${data.receiptId}`)
      .then(response => {
        return {
          receipt: response.data.receipt != null
            ? response.data.receipt : {},
          }});
  },

  confirmAdminReceipt: (payload) => {
    return axios.put(`/api/pv/admin/receipts/${payload.entityId}/confirm`, payload)
      .then(response => ({
        receipt: response.data.receipt != null
          ? response.data.receipt : {},
      }));
  },
  confirmAdminRegistration: (payload) => {
    return axios.put(`/api/pv/admin/receipts/${payload.receiptId}/registration/confirm`, payload)
      .then(response => ({
        receipt: response.data.receipt != null
          ? response.data.receipt : {},
      }));
  },

  addAdminReceiptComment: (payload) => {
    return axios.put(`/api/pv/admin/receipts/${payload.entityId}/comment`, payload)
      .then(response => ({
        receipt: response.data.receipt != null
          ? response.data.receipt : {},
      }));
  },

  deleteAdminReceiptComment: (payload) => {
    return axios.delete(`/api/pv/admin/receipts/${payload.entityId}/comment/${payload.commentId}`)
      .then(response => ({
        receipt: response.data.receipt != null
          ? response.data.receipt : {},
      }));
  },

  confirmAdminCashback: (payload) => {
    return axios.put(`/api/pv/admin/receipts/${payload.entityId}/cashback/confirm`, payload)
      .then(response => ({
        receipt: response.data.receipt != null
          ? response.data.receipt : {},
      }));
  },

  addAdminReceiptDelayedCtaBlock: (payload) => {
    return axios.put(`/api/pv/admin/receipts/${payload.entityId}/delayedcta/block`, payload)
      .then(response => ({
        receipt: response.data.receipt != null
          ? response.data.receipt : {},
      }));
  },

  confirmAdminReceiptAfterDone: (payload) => {
    return axios.put(`/api/pv/admin/receipts/${payload.entityId}/confirm/next`, payload)
      .then(response => ({
        receipt: response.data.receipt != null
          ? response.data.receipt : {},
      }));
  },

  setAdminReceiptCtaDone: (payload) => {
    return axios.put(`/api/pv/admin/receipts/${payload.receiptId}/cta-done`, payload)
      .then(response => ({
        receipt: response.data.receipt != null
          ? response.data.receipt : {},
      }));
  },

  saveAdminReceipt: (payload) => {
    return axios.put(`/api/pv/admin/receipts/${payload.receiptId}`, payload)
      .then(response => ({
        receipt: response.data.receipt != null
          ? response.data.receipt : {},
      }));
  },

  getAdminReceiptPrize: (receiptId) => {
    return axios.get(`/api/pv/admin/receipts/${receiptId}/retry-prize`)
      .then(response => ({
        receipt: response.data.receipt != null
          ? response.data.receipt : {},
        message: response.data.message != null
          ? response.data.message : '',
      }));
  },

  cloneAdminReceipt: data => {
    return axios.post(`/api/pv/admin/receipts/${data.receiptId}/clone/`).then(response => {
      return {
        clone: response.data != null ? response.data : []
      };
    });
  },

  reviewAdminReceipt: (payload) => {
    return axios.post(`/api/pv/admin/receipts/${payload.receiptId}/review`, payload.reviewData)
      .then(response => ({
        receipt: response.data.receipt != null
          ? response.data.receipt : {},
      }));
  },

  deleteAdminReceipt: (payload) => {
    return axios.delete(`/api/pv/admin/receipts/${payload.receiptId}?deleteCode=${payload.deleteCode}`)
      .then(response => ({
        message: response.data.message != null
          ? response.data.message : '',
      }));
  },

  testPVActions: (payload) => {
    return axios.post(`/api/pv/admin/receipts/${payload.receiptId}/actions`, payload)
      .then(response => ({
        message: response.data.message != null
          ? response.data.message : '',
      }));
  },

  forceAdminPVAction: (payload) => {
    return axios.post(`/api/pv/admin/receipts/${payload.receiptId}/actions/${payload.actionId}`, payload)
      .then(response => ({
        receipt: response.data.receipt != null
          ? response.data.receipt : {},
      }));
  },

  tryAdminConsumerFlow: (payload) => {
    return axios.post(`/api/pv/admin/receipts/${payload.receiptId}/try`, payload)
      .then(response => ({
        token: response.data.token != null
          ? response.data.token : '',
      }));
  },

  addAdminPVReceiptMedia: (payload) => {
    return axios.put(`/api/pv/admin/receipts/${payload.entityId}/media`, payload.data, payload.config)
      .then(response => ({
        receipt: response.data.receipt != null
          ? response.data.receipt : {},
      }));
  },

  // Comapny
  getCompanyPVActivation: (entityId) => {
    return axios.get(`/api/pv/partner/activations/${entityId}`)
      .then(response => {
        return {
          activation: response.data.activation != null
            ? response.data.activation : {},
          }});
  },

  findCompanyAllReceipts: (data) => {
    return axios.put('/api/pv/partner/allreceipts', data)
      .then(response => {
        return {
          receipts: response.data.receipts != null
            ? response.data.receipts : [],
          receiptsTotal: response.data.receiptsTotal != null
            ? response.data.receiptsTotal : 0,
          }});
  },

  updateCompanyReceiptByKey: (data) => {
    return axios.put(`/api/pv/partner/receipts/${data.receiptId}/bykey`, data)
      .then(response => {
        return {
          receipt: response.data.receipt != null
            ? response.data.receipt : {},
          }});
  },

  getCompanyReceipt: (data) => {
    return axios.get(`/api/pv/partner/receipts/${data.receiptId}`)
      .then(response => {
        return {
          receipt: response.data.receipt != null
            ? response.data.receipt : {},
          }});
  },

  confirmCompanyReceipt: (payload) => {
    return axios.put(`/api/pv/partner/receipts/${payload.entityId}/confirm`, payload)
      .then(response => ({
        receipt: response.data.receipt != null
          ? response.data.receipt : {},
      }));
  },
  confirmCompanyRegistration: (payload) => {
    return axios.put(`/api/pv/partner/receipts/${payload.receiptId}/registration/confirm`, payload)
      .then(response => ({
        receipt: response.data.receipt != null
          ? response.data.receipt : {},
      }));
  },

  addCompanyReceiptComment: (payload) => {
    return axios.put(`/api/pv/partner/receipts/${payload.entityId}/comment`, payload)
      .then(response => ({
        receipt: response.data.receipt != null
          ? response.data.receipt : {},
      }));
  },

  confirmCompanyCashback: (payload) => {
    return axios.put(`/api/pv/partner/receipts/${payload.entityId}/cashback/confirm`, payload)
      .then(response => ({
        receipt: response.data.receipt != null
          ? response.data.receipt : {},
      }));
  },

  addCompanyReceiptDelayedCtaBlock: (payload) => {
    return axios.put(`/api/pv/partner/receipts/${payload.entityId}/delayedcta/block`, payload)
      .then(response => ({
        receipt: response.data.receipt != null
          ? response.data.receipt : {},
      }));
  },

  saveCompanyReceipt: (payload) => {
    return axios.put(`/api/pv/partner/receipts/${payload.receiptId}`, payload)
      .then(response => ({
        receipt: response.data.receipt != null
          ? response.data.receipt : {},
      }));
  },

  cloneCompanyReceipt: data => {
    return axios.post(`/api/pv/partner/receipts/${data.receiptId}/clone/`).then(response => {
      return {
        clone: response.data != null ? response.data : []
      };
    });
  },

  deleteCompanyReceipt: (payload) => {
    return axios.delete(`/api/pv/partner/receipts/${payload.receiptId}?deleteCode=${payload.deleteCode}`)
      .then(response => ({
        message: response.data.message != null
          ? response.data.message : '',
      }));
  },

  forceCompanyPVAction: (payload) => {
    return axios.post(`/api/pv/partner/receipts/${payload.receiptId}/actions/${payload.actionId}`, payload)
      .then(response => ({
        receipt: response.data.receipt != null
          ? response.data.receipt : {},
      }));
  },

  confirmCompanyReceiptAfterDone: (payload) => {
    return axios.put(`/api/pv/partner/receipts/${payload.entityId}/confirm/next`, payload)
      .then(response => ({
        receipt: response.data.receipt != null
          ? response.data.receipt : {},
      }));
  },
};
